import { Reason } from "lib";
import { observable, action } from "mobx";
import { callWithPromise } from "utils";

export class BlacklistStore {
  @observable loading?: boolean;
  @observable selectedItems: string[] = [];

  @action
  setSelectedItems(value: string[]) {
    this.selectedItems = value;
  }

  @action
  deleteBlacklists() {
    const self = this;
    this.loading = true;
    try {
      callWithPromise("blacklist.removeById", {
        id: self.selectedItems
      });
    } catch (err) {
      console.log(err.message);
    }
    this.loading = false;
  }

  @action
  clearBlacklists() {
    this.loading = true;
    try {
      callWithPromise("blacklist.removeAll", {
        reason: [Reason.Crud, Reason.Jerk, Reason.Spam]
      });
    } catch (err) {
      console.log(err.message);
    }
    this.loading = false;
  }
}
